module.exports = __webpack_public_path__ + "static/media/fa-solid-900.44d537ab.woff2";